import Link from 'next/link';

import { SITE_BASE_PATH } from '@/configs/site';
import { joinSgcmMsSite } from '@/utils/url/join/public';

import styles from './style.module.scss';
import type { Component } from './types';

export const PastCarDescription: Component = ({
  searchInput,
  total,
}) => (
  <>
    <div className={styles.containerSummary}>
      There are
      {' '}
      <span className={styles.textBold}>
        {total || 'no'}
        {' '}
        Past New Cars for Sale
      </span>
      {' '}
      no longer
      being sold by local distributors
    </div>
    {searchInput && (
      <div className={styles.containerSummary}>
        View all
        {' '}
        <Link
          className={styles.textPastCars}
          href={`${joinSgcmMsSite(SITE_BASE_PATH ?? '')}/past-cars?q=${searchInput}`}>
          {' '}
          past
          {' '}
          {searchInput}
          {' '}
          cars
        </Link>
      </div>
    )}
  </>
);
